import angular from 'angular';
import SourceFileService from './sourceFileService.service';

let sourceFileServiceModule = angular.module('sourceFileService', []).service('sourceFileService', SourceFileService);

export default sourceFileServiceModule;



// WEBPACK FOOTER //
// ./app/common/sourceFileService/sourceFileService.js